<ng-container *ngIf="canDisplayGrid()">

  <h5 class="first mg-b-38">
    <span class="badge badge-primary mg-r-5">{{infoPlcRepas.repas.libelle | uppercase}}</span>
    <span class="badge badge-success mg-r-5">{{infoPlcRepas.cmcContrainteAlim.cmcLibelle | uppercase}}</span>
    <span class="badge badge-warning mg-r-5">{{infoPlcRepas.cmcContrainteAlim.regimeLibelle | uppercase}}</span>
    <span class="badge badge-info mg-r-5">{{infoPlcRepas.dateMenu  | date:'EEEE d LLLL'  | uppercase}}</span>
  </h5>

  <div [style.width.px]="800">
    <p-table
      [scrollHeight]="utils.scrollHeightContent(150)"
      styleClass="p-datatable-sm"
      [scrollable]="true"
      [value]="_plcRepas.rows">


      <!--HEADER-->
      <ng-template pTemplate="header">

        <tr>
          <th [style.width.px]="150">Composante Repas</th>
          <th [style.width.px]="300">Plat</th>
          <th [style.width.px]="100" pTooltip="Taux de prise en %">Tdp %</th>
          <th [style.width.px]="80">
            <!--          TYPE EFFECTIF-->
            <ng-container *ngTemplateOutlet="tplThEffectif"></ng-container>
          </th>

        </tr>
      </ng-template>

      <!--BODY-->
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr [class.modification-manuelle]="rowData?.plat?.modificationManuelle"
            [class.disable]="rowData.cmcrPlcDate.statutMenuCode != STATUTS_MENUS.SAISIE_EFFECTIFS">

          <td [style.width.px]="150">
            {{rowData.decoupageRepas.libelle}} {{rowData.ordre}}
          </td>


          <td [style.width.px]="300">

            <ng-container *ngIf="!utils.isNullOrEmpty(rowData.plat)">

              <div [pTooltip]="getHistoLabel(rowData.plat)" tooltipPosition="bottom" [escape]="false" showDelay="500"
                   style="width: 100%">
                <ng-container *ngIf="rowData.plat.actif">
                <span>
                {{rowData?.plat?.produitDeclinaison?.libelle}}
                </span>
                </ng-container>
                <ng-container *ngIf="!rowData.plat.actif">
                  &nbsp;
                </ng-container>

              </div>
            </ng-container>

          </td>


          <td [style.width.px]="100" class="text-right">
            <ng-container *ngTemplateOutlet="tplTauxDePrise;context:{row:rowData}"></ng-container>
          </td>
          <td [style.width.px]="80" class="text-right">
            <ng-container *ngTemplateOutlet="tplEffectif;context:{row:rowData}"></ng-container>
          </td>

        </tr>

      </ng-template>

      <!--SUMMARY-->
      <ng-template pTemplate="summary">
        <tr>
          <td colspan="4">
            <div class="font-weight-normal font-12 text-left">
              <i class="fas fa-square edit-color mg-r-5 border"></i>Plat ajouté/modifié/supprimé manuellement.
            </div>
          </td>
        </tr>
      </ng-template>


    </p-table>
  </div>

</ng-container>

<!--TEMPLATE TH TYPE EFFECTIF-->
<ng-template #tplThEffectif>
  <ng-container [ngSwitch]="typeEffectif">
    <ng-container *ngSwitchCase="EffectifMode.Prevision">
      <span pTooltip="Effectif prévisionnel">Eff. prév.</span>
    </ng-container>

    <ng-container *ngSwitchCase="EffectifMode.Fabrication">
      <span pTooltip="Effectif pour la fabrication">Eff. fab.</span>
    </ng-container>

    <ng-container *ngSwitchCase="EffectifMode.Facturation">
      <span pTooltip="Effectif pour la facturation">Eff. factu.</span>
    </ng-container>
  </ng-container>
</ng-template>

<!--TEMPLATE  EFFECTIF-->
<ng-template #tplEffectif let-row="row">

  <ng-container *ngIf="!utils.isNullOrEmpty(row.plat)">

    <ng-container [ngSwitch]="typeEffectif">

      <ng-container *ngSwitchCase="EffectifMode.Prevision">

        <input pInputText pKeyFilter="pint"
               min="0"
               [(ngModel)]="row.plat.effectifPrevisionnel"
               [disabled] = isEffectifInputDisabled(row)
               (click)="$event.stopPropagation()"
               (keydown)="changeEffectif($event,row.plat,'effectifPrevisionnel')"
               class="cell text-right bold "
               [class.arrondi]="row.plat.aEffectifPrevisionnel"
               [class.disable]="isInputDisabled(row)"

        >

      </ng-container>

      <ng-container *ngSwitchCase="EffectifMode.Fabrication">

        <input pInputText pKeyFilter="pint"
               min="0"
               [(ngModel)]="row.plat.effectifFabrication"
               [disabled] = isEffectifInputDisabled(row)
               (click)="$event.stopPropagation()"
               (keydown)="changeEffectif($event,row.plat,'effectifFabrication')"
               class="cell text-right bold "
               [class.arrondi]="row.plat.aEffectifFabrication"
               [class.disable]="isInputDisabled(row)"
        >

      </ng-container>

      <ng-container *ngSwitchCase="EffectifMode.Facturation">

        <input pInputText pKeyFilter="pint"
               min="0"
               [(ngModel)]="row.plat.effectifFacture"
               [disabled] = isEffectifInputDisabled(row)
               (click)="$event.stopPropagation()"
               (keydown)="changeEffectif($event,row.plat,'effectifFacture')"
               class="cell text-right bold"
               [class.arrondi]="row.plat.aEffectifFacture"
               [class.disable]="isInputDisabled(row)"
        >

      </ng-container>


    </ng-container>


  </ng-container>
</ng-template>


<!--TEMPLATE  TAUX DE PRISE-->
<ng-template #tplTauxDePrise let-row="row">

  <ng-container *ngIf="!utils.isNullOrEmpty(row.plat)">

    <ng-container [ngSwitch]="typeEffectif">
      <ng-container *ngSwitchCase="EffectifMode.Prevision">

        <input pInputText pKeyFilter="pnum"
               min="0"
               [class.disable]="isEffectifInputDisabled(row)"
               [(ngModel)]="row.plat.tpEffectifPrevisionnel"
               (click)="$event.stopPropagation()"
               (keydown)="changeTauxDePrise($event,row.plat,'tpEffectifPrevisionnel')"
               class="cell text-right  bold">

      </ng-container>

      <ng-container *ngSwitchCase="EffectifMode.Fabrication">

        <input pInputText pKeyFilter="pnum"
               min="0"
               [class.disable]="isEffectifInputDisabled(row)"
               [(ngModel)]="row.plat.tpEffectifFabrication"
               (click)="$event.stopPropagation()"
               (keydown)="changeTauxDePrise($event,row.plat,'tpEffectifFabrication')"
               class="cell text-right bold">

      </ng-container>

      <ng-container *ngSwitchCase="EffectifMode.Facturation">

        <input pInputText pKeyFilter="pnum"
               min="0"
               [class.disable]="isEffectifInputDisabled(row)"
               [(ngModel)]="row.plat.tpEffectifFacture"
               (click)="$event.stopPropagation()"
               (keydown)="changeTauxDePrise($event,row.plat,'tpEffectifFacture')"
               class="cell text-right  bold">

      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>


